import { Purchase } from 'piconetworks/pkg-module-purchase'
// import Purchase from 'pkgs/picore/src/packages/Modules/Purchase/index'

// import Purchase from '../../pkgs/picore/src/packages/Modules/Purchase/index'
import createDuck from '../baseDuck'

export default Purchase({
    createDuck,
})
